import { render, staticRenderFns } from "./sellRewardList.vue?vue&type=template&id=c9024bf8&scoped=true"
import script from "./sellRewardList.vue?vue&type=script&lang=js"
export * from "./sellRewardList.vue?vue&type=script&lang=js"
import style0 from "./sellRewardList.vue?vue&type=style&index=0&id=c9024bf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9024bf8",
  null
  
)

export default component.exports